/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

import useHandleError from 'src/hooks/use-handle-error';

import { momentDate } from 'src/utils/moment-format';

import guestApi from 'src/api/guestApi';

type UseTermsPoliciesReturnType = {
  effectiveDate: string;
  htmlContent: string | undefined;
};

export enum PolicyType {
  TERMS = 'TERMS_OF_SERVICE',
  PRIVACY = 'PRIVACY_STATEMENT',
}

export const useTermsPolicies = ({ type }: { type: PolicyType }): UseTermsPoliciesReturnType => {
  const handleError = useHandleError();

  const [effectiveDate, setEffectiveDate] = useState('');

  const [htmlContent, setHtmlContent] = useState<string | undefined>();

  const brandCode = localStorage.getItem('brandCode') ?? '';

  const fetchData = handleError(async () => {
    const response = await guestApi.terms({ brandCode });

    const privacyUrl = response.data.data.PRIVACY_STATEMENT;
    const termsUrl = response.data.data.TERMS_OF_SERVICE;

    let policyUrl = '';
    switch (type) {
      case PolicyType.TERMS:
        policyUrl = termsUrl;
        break;
      case PolicyType.PRIVACY:
        policyUrl = privacyUrl;
        break;
      default:
        return;
    }

    // TD: Remove when the API of other terms is provided
    if (!policyUrl) {
      setHtmlContent('<p>Content not available at the moment.</p>');
    }

    const contentResponse = await guestApi.policyContents(policyUrl, 'text');

    setHtmlContent(contentResponse.data);
  });

  const fetchEffectiveDate = handleError(async () => {
    const params = {
      type: type === PolicyType.PRIVACY ? PolicyType.PRIVACY : PolicyType.TERMS,
      brandCode,
    };

    const response = await guestApi.termsDate(params);

    if (response.data.data) {
      setEffectiveDate(momentDate(response.data.data));
    }
  });

  useEffect(() => {
    fetchData();

    fetchEffectiveDate();
  }, []);

  return {
    effectiveDate,
    htmlContent,
  };
};
